module.exports = __webpack_public_path__ + "components/flag/static/square/va-cd3d95dbef867684f00d81773fdb617b.svg";